export default "__VITE_ASSET__DPhyC8xC__"